<template>
  <div>
    <v-card tile flat class="my-5">
      <v-card-text class="pa-0">
        <v-row no-gutters>
          <v-col cols="2">
            <div class="bg-kiri"></div>
          </v-col>
          <v-col cols="10" class="pa-5">
            <v-row dense>
              <v-col cols="12" md="9" sm="12">
                <h1 class="headline" v-if="isEdit"> <strong>Instruksi</strong> Pemeriksaan </h1>
                <h1 class="headline" v-else> <strong>Hasil</strong> Pemeriksaan </h1>
              </v-col>
            </v-row>
            <p v-if="isEdit">
              Anda perlu memeriksa keabsahan dokumen yang dikirimkan oleh fasilitator program sekolah penggerak di bawah
              ini. Lakukan verval dengan memilih data sudah sesuai atau tolak dengan perbaikan (dengan mengisikan
              perbaikannya pada bagian Akhir)
            </p>
            <v-alert v-if="isEdit" class="yellow lighten-4">
              <p class="ma-0 text-justify">
                Berikut adalah pengajuan perubahan data pada {{ $localDate(biodataEdit.wkt_ajuan) }}, silakan melakukan
                pengecekan data secara menyeluruh. untuk perubahan data terbaru ditandai dengan tulisan berwarna
                <strong>jingga</strong>. untuk melihat rekap perubahan data dapat dicek melalui tombol di bawah.
              </p>
              <div class="mt-2">
                <v-btn depressed color="orange" class="text-capitalize" dark small @click="onViewRekap">
                  <v-icon left>mdi-eye</v-icon> Rekap Perubahan
                </v-btn>
              </div>
            </v-alert>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-card flat class="mb-3">
      <v-card-text>
        <v-alert
          v-if="$getDeepObj(detail, 'is_luar_sasaran')"
          icon="mdi-information-outline"
          text
          color="error"
          class="mb-0"
        >
          <v-row align="center" no-gutters>
            <v-col cols="12" md="9" class="grow">
              <strong>Pengawas bukan berasal dari Daerah Sasaran</strong>
            </v-col>
          </v-row>
        </v-alert>
        <div class="mb-3">
          <v-row v-if="detail && detail.lulus_tahap === 2">
            <v-col cols="12" class="my-auto">
              <h2 class="grey--text">Informasi Umum Kandidat Fasilitator</h2>
            </v-col>
          </v-row>
          <v-row v-else>
            <v-col cols="12" sm="12" md="6" class="my-auto">
              <h2 class="grey--text">Detail Profil FSP</h2>
            </v-col>
            <v-col cols="12" md="6">
              <div class="body-1 warning--text text-right">
                <strong>Fasilitator</strong>
              </div>
            </v-col>
          </v-row>
        </div>
        <v-divider />
        <!-- CV -->
        <v-list three-line class="pa-0 mb-4">
          <v-row dense>
            <v-col md="6" sm="12" cols="12">
              <div style="border: thin solid rgba(0, 0, 0, 0.12)">
                <v-expansion-panels tile flat v-model="panel">
                  <v-expansion-panel v-for="(item, key) in profil" :key="key">
                    <v-expansion-panel-header class="px-4 subtitle-2">
                      <b>{{ M_LABEL[key] }}</b>
                    </v-expansion-panel-header>
                    <v-divider></v-divider>
                    <v-expansion-panel-content class="px-0 custom-pnl">
                      <template v-for="(sch, id) in item">
                        <v-col cols="12" sm="12" md="12" :lg="sch.size" :key="id">
                          <h3 v-if="sch.title" class="py-2 info--text" style="border-bottom: 1px solid #cccccc">
                            {{ sch.title }}
                          </h3>
                          <v-row class="pt-3">
                            <template v-for="(item, idItem) in sch.items">
                              <v-col v-if="!item.hidden" cols="12" sm="12" md="12" :lg="item.size || 6" :key="idItem">
                                <div class="grey--text">
                                  <span class="subtitle-2 font-weight-regular">{{ item.label }}</span>
                                </div>
                                <template>
                                  <span
                                    v-if="item.value && item.type === 'wa'"
                                    :class="['subtitle-1', item.update ? 'orange--text' : 'black--text']"
                                  >
                                    {{ item.value }}
                                    <v-icon
                                      color="success"
                                      small
                                      dark
                                      right
                                      class="ml-1 mb-1"
                                      @click="onCall(Number(item.value))"
                                    >
                                      mdi-whatsapp
                                    </v-icon>
                                  </span>
                                  <span
                                    v-else-if="item.value"
                                    :class="['subtitle-1', item.update ? 'orange--text' : 'black--text']"
                                    v-html="item.value"
                                  />
                                  <span v-else class="red--text">Belum dilengkapi</span>
                                </template>
                              </v-col>
                            </template>
                          </v-row>
                        </v-col>
                      </template>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </div>
            </v-col>
            <v-col md="6" sm="12" cols="12">
              <v-list class="pa-2" outlined>
                <v-subheader class="subtitle-2 black--text"><strong>DOKUMEN ADMINISTRASI</strong> </v-subheader>
                <v-divider />
                <v-row dense>
                  <template v-for="(item, i) in dokumen">
                    <v-col :key="i" md="12" sm="12" cols="12">
                      <v-list dense class="py-0" max-height="80">
                        <v-list-item>
                          <v-list-item-icon class="my-auto" size="4">
                            <v-icon color="red" dark left>mdi-file-pdf</v-icon>
                          </v-list-item-icon>
                          <v-list-item-content class="my-auto">
                            <v-row no-gutters>
                              <v-col cols="12" md="8" sm="12" class="my-auto">
                                <div>{{ item.text }}</div>
                                <div class="info--text" v-if="[].includes(Number(item.value))" type="red">
                                  * Dokumen bersifat
                                </div>
                              </v-col>
                              <v-col cols="12" md="4" sm="12">
                                <v-btn
                                  depressed
                                  small
                                  :disabled="!item.url"
                                  :color="item.update ? 'orange' : 'primary'"
                                  :href="item.url"
                                  class="white--text"
                                  target="_blank"
                                >
                                  <v-icon left>mdi-eye</v-icon>Lihat berkas
                                </v-btn>
                              </v-col>
                            </v-row>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>
                      <v-divider v-if="i + 1 !== dokumen.length" />
                    </v-col>
                  </template>
                </v-row>
              </v-list>
            </v-col>
          </v-row>
        </v-list>
      </v-card-text>
    </v-card>
    <v-card flat>
      <v-card-text>
        <v-list
          three-line
          class="pa-0 mb-4"
          v-if="biodataBaru && [6, 2, 3].includes(biodataBaru.k_verval_psp) && catatan"
        >
          <v-row dense>
            <v-col cols="12">
              <v-list class="pa-2" outlined three-line>
                <v-list-item>
                  <v-list-item-avatar :rounded="false" tile size="80">
                    <v-icon size="60">mdi-file-document-edit-outline</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content class="py-0">
                    <div class="black--text my-2 ml-1">
                      <h3>Catatan Verval Sebelumnya</h3>
                      <p class="body-2 mb-0" v-html="catatan || '-'"></p>
                    </div>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-col>
          </v-row>
        </v-list>
        <v-list three-line class="pa-0 mb-4">
          <v-list-item>
            <v-list-item-avatar :rounded="false" tile size="80">
              <v-icon size="60">mdi-file-document-edit-outline</v-icon>
            </v-list-item-avatar>
            <v-list-item-content class="py-0" v-if="[3, 5, 6].includes(biodataBaru && biodataBaru.k_verval_psp)">
              <div class="black--text my-2 ml-1">
                <h2>Pemeriksaan Dokumen</h2>
                <p class="subtitle-1 my-1">
                  Berikan Penilaian pada kelengkapan dan keabsahan dokumen ini, Apakah semua dokumen sah dan sesuai
                  dengan data yang di inputkan kandidat?
                </p>
              </div>
              <v-card flat :disabled="!isEdit">
                <v-row dense>
                  <template v-for="item in mBtnPilihan">
                    <v-col :key="item.value" cols="12" md="4" class="my-auto">
                      <v-btn
                        block
                        class="white--text"
                        :color="item.color"
                        :outlined="pilihan !== item.value"
                        depressed
                        @click="onSelected(item.value)"
                        style="background-color: white"
                      >
                        <v-icon small left>{{ item.icon }}</v-icon>
                        {{ item.label }}
                      </v-btn>
                    </v-col>
                  </template>
                </v-row>
              </v-card>
              <div>
                <template v-if="pilihan && !isDisable">
                  <div class="py-4" v-if="$isObject(schema[pilihan])">
                    <div class="mt-4">
                      <base-form-generator :schema="[schema[pilihan]]" v-model="form" />
                    </div>
                  </div>
                  <div class="py-4" v-else-if="$isObject(schema[pilihan])">
                    <h4 class="black--text">
                      {{ schema[pilihan]['label'] }} {{ schema[pilihan]['unrequired'] ? '' : '*' }}
                    </h4>
                    <div class="mt-1">
                      <validation-provider
                        mode="passive"
                        :name="schema[pilihan]['label']"
                        :rules="schema[pilihan]['unrequired'] ? '' : 'required'"
                        v-slot="{ errors }"
                      >
                        <v-combobox
                          v-model="form['catatan']"
                          :search-input.sync="search"
                          :items="schema[pilihan]['items']"
                          :error-messages="errors"
                          label="Silakan memilih alasan pada pilihan atau buat alasan lainnya (ketik manual kemudian tekan enter)"
                          :hide-selected="jenisBerkas !== 'berkas-mundur'"
                          multiple
                          persistent-hint
                          small-chips
                          outlined
                          dense
                          single-line
                          hide-details
                          clearable
                        >
                          <template slot="item" slot-scope="data">
                            <p v-html="data.item.text"></p>
                          </template>
                          <template v-slot:no-data>
                            <v-list-item>
                              <v-list-item-content>
                                <v-list-item-title>
                                  Alasan dengan kata kunci <strong>"{{ search }}"</strong> tidak ditemukan. Tekan tombol
                                  <kbd>enter</kbd> untuk membuat alasan Anda menjadi pilihan.
                                </v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </template>
                        </v-combobox>
                      </validation-provider>
                    </div>
                  </div>
                </template>
              </div>
            </v-list-item-content>
            <v-list-item-content v-else-if="biodataBaru && [4, 5].includes(biodataBaru.k_verval_psp)">
              <v-row dense>
                <v-col cols="12">
                  <v-list class="pa-2" outlined>
                    <v-list-item>
                      <v-list-item-content>
                        <v-row>
                          <v-col cols="12" sm="12" md="1" class="my-auto">
                            <v-avatar tile rounded>
                              <v-icon size="60">mdi-file-document-edit-outline</v-icon>
                            </v-avatar>
                          </v-col>
                          <v-col cols="12" sm="12" md="11">
                            <div class="black--text my-2 ml-1">
                              <h3>Catatan Hasil Pemeriksaan Dokumen</h3>
                              <p class="body-2 mb-0" v-html="catatan || '-'"></p>
                            </div>
                          </v-col>
                        </v-row>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>
              </v-row>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card-text>
    </v-card>
    <popup-preview-detail ref="view" :url="view.url || ''" :title="view.title || ''">
      <v-container fluid class="px-2">
        <v-card flat class="py-0">
          <v-alert color="red" text border="left" type="info">
            Pastikan nama dan data pada profil sesuai dengan dokumen yang telah di inputkan
          </v-alert>
          <v-list three-line class="px-2 my-n5">
            <v-row dense no-gutters>
              <template v-for="(item, i) in view.info">
                <v-col
                  v-if="!item.hidden"
                  :key="i"
                  :md="item.label === 'Keterangan' ? 12 : item.label === 'Alamat' ? 6 : 3"
                  sm="12"
                  cols="12"
                >
                  <v-list-item-content>
                    <v-list-item-title class="subtitle-2 grey--text my-n1">{{ item.label }}</v-list-item-title>
                    <div class="subtitle-1 black--text" v-html="item.value" />
                  </v-list-item-content>
                </v-col>
              </template>
            </v-row>
          </v-list>
        </v-card>
      </v-container>
    </popup-preview-detail>
    <popup-rekap
      v-if="$isObject(detail)"
      ref="rekap"
      :edit="detail"
      :biodata="detail.biodata || {}"
      :biodata-edit="detail.biodata_baru || {}"
      :key-biodata-updates="keyBiodataUpdates"
      :key-berkas-updates="keyBerkasUpdates"
      @approve="onConfirmSave"
    />
  </div>
</template>
<script>
import BaseFormGenerator from '@components/base/BaseFormGenerator';
import PopupPreviewDetail from '@components/popup/PreviewDetil';
import PopupRekap from '@views/gtk/biodata/popup/Rekap';
import Panduan from './panduan';
import { ValidationProvider } from 'vee-validate';
export default {
  name: 'FormBerkas',
  components: { BaseFormGenerator, PopupPreviewDetail, PopupRekap, ValidationProvider },
  props: {
    masters: {
      default: () => {},
    },
    detail: {
      default: () => {},
    },
    id: {
      type: [Number, String],
      default: 0,
    },
    configs: {
      default: () => {},
    },
    berkas: {
      default: () => [],
    },
    angkatan: {
      type: Number,
      default: 1,
    },
    isEdit: {
      type: Boolean,
      default: true,
    },
    isDisable: {
      type: Boolean,
      default: false,
    },
    statistik: {
      type: Object,
      default: () => {},
    },
    initValue: {
      type: Object,
      default: () => null,
    },
    jenis: {
      type: String,
      default: () => 'kasek',
    },
    jenisBerkas: {
      type: String,
      default: () => '',
    },
  },
  mixins: [Panduan],

  data() {
    return {
      view: {},
      panel: 0,
      pilihan: null,
      search: null,
      form: {},
      M_LABEL: {
        biodata: 'PROFIL',
        penugasan: 'REFERENSI PENUGASAN',
        administrasi: 'DATA PENDUKUNG ADMINISTRASI',
        instansi: 'DATA INSTANSI',
      },
      mBedaInstansi: {
        51001: 'Ya',
        51002: 'Tidak',
        51003: 'Tidak memiliki Instansi',
      },
      mBedaTugas: {
        51001: 'Tidak',
        51002: 'Ya',
        51003: 'Tidak memiliki Instansi',
      },
    };
  },

  computed: {
    biodataBaru() {
      return this.$getDeepObj(this.detail, 'biodata_baru') || {};
    },

    biodataEdit() {
      return this.$getDeepObj(this.detail, 'biodata_edit') || {};
    },

    tugasEdit() {
      if (!this.isEdit) {
        return {};
      }

      return this.$getDeepObj(this.detail, 'tugas_edit') || {};
    },

    updates() {
      const pspBiodataEditDatas = this.biodataEdit.psp_biodata_edit_datas || [];

      return {
        biodata: pspBiodataEditDatas.filter((update) => update.model_type === 'Modules\\Psp\\Models\\PspBiodata'),
        tugas: pspBiodataEditDatas.filter((update) => update.model_type === 'Modules\\Psp\\Models\\PspBiodataTugas'),
        berkas: pspBiodataEditDatas.filter((update) => update.model_type === 'Modules\\Psp\\Models\\PspBiodataBerkas'),
      };
    },

    keyBiodataUpdates() {
      let result = [];

      if (!this.isEdit) {
        return result;
      }

      for (const biodata of this.updates.biodata || []) {
        const keys = Object.keys(biodata.final) || [];

        result = [...result, ...keys];
      }

      return result;
    },

    keyBerkasUpdates() {
      if (!this.isEdit) {
        return [];
      }

      return (this.updates.berkas || []).map((update) => +update.model_id);
    },

    tipe() {
      return {
        kasek: { key: 'kasek', label: 'Kepala Sekolah' },
        instruktur: { key: 'instruktur', label: 'Fasilitator' },
      };
    },

    catatan() {
      return this.biodataEdit.catatan || '';
    },

    ptk() {
      return this.$getDeepObj(this.biodataBaru, 'ptk') || {};
    },

    pspProfil() {
      return this.$getDeepObj(this.biodataBaru, 'psp_profil') || {};
    },

    rencanas() {
      return (this.$getDeepObj(this.biodataBaru, 'psp_biodata_tugases') || [])
        .filter((tugas) => tugas.status_gelombang === 'rencana')
        .sort((a, b) => a.prioritas - b.prioritas)
        .map((t, id) => {
          return `${id + 1}. ${this.$getDeepObj(t, 'm_jenjang.singkat')}`;
        });
    },

    aktifs() {
      return (this.$getDeepObj(this.biodataBaru, 'psp_biodata_tugases') || [])
        .filter((tugas) => tugas.status_gelombang === 'aktif')
        .map((t) => {
          return `${t.jml_pendampingan || 0} ${this.$getDeepObj(t, 'm_jenjang.singkat')}`;
        });
    },

    lamas() {
      return (this.$getDeepObj(this.biodataBaru, 'psp_biodata_tugases') || [])
        .filter((tugas) => tugas.status_gelombang === 'selesai')
        .map((t) => {
          return `${this.$getDeepObj(t, 'm_jenjang.singkat')}`;
        });
    },

    dasar() {
      return [
        { label: 'Nama', value: this.ptk.nama || '-' },
        { label: 'NIK', value: this.$getDeepObj(this.pspProfil, 'nik') || '-' },
        {
          label: 'Nomor SIMPKB',
          value:
            (this.biodataBaru && this.$getDeepObj(this.biodataBaru, 'ptk_id')) || (this.ptk && this.ptk.ptk_id) || '-',
        },
        { label: 'Tempat Lahir', value: this.ptk.tmp_lahir || '-' },
        { label: 'Tanggal Lahir', value: this.$localDate(this.ptk.tgl_lahir) || '' },
        { label: 'Usia', value: this.ptk.umur || '-' },
        {
          label: 'Alamat (sesuai KTP)',
          value: this.$getDeepObj(this.biodataBaru, 'alamat_ktp') || '',
          update: this.keyBiodataUpdates.includes('alamat_ktp'),
        },
        {
          label: 'Provinsi (sesuai KTP)',
          value: this.$getDeepObj(this.biodataBaru, 'm_propinsi_ktp.keterangan') || '',
          update: this.keyBiodataUpdates.includes('k_propinsi_ktp'),
        },
        {
          label: 'Kabupaten/Kota (sesuai KTP)',
          value: this.$getDeepObj(this.biodataBaru, 'm_kota_ktp.keterangan') || '',
          update: this.keyBiodataUpdates.includes('k_kota_ktp'),
        },
        {
          label: 'Alamat (tempat tinggal sekarang)',
          value: this.$getDeepObj(this.biodataBaru, 'alamat') || '',
          update: this.keyBiodataUpdates.includes('alamat'),
        },
        {
          label: 'Provinsi (tempat tinggal sekarang)',
          value: this.$getDeepObj(this.biodataBaru, 'm_propinsi.keterangan') || '',
          update: this.keyBiodataUpdates.includes('k_propinsi'),
        },
        {
          label: 'Kabupaten/Kota (Tempat tinggal sekarang)',
          value: this.$getDeepObj(this.biodataBaru, 'm_kota.keterangan') || '',
          update: this.keyBiodataUpdates.includes('k_kota'),
        },
        {
          label: 'Kode Pos',
          value: this.$getDeepObj(this.biodataBaru, 'kodepos') || '',
          update: this.keyBiodataUpdates.includes('kodepos'),
        },
      ];
    },

    kontak() {
      return [
        {
          label: 'No Telepon (HP)',
          value: this.$getDeepObj(this.biodataBaru, 'no_hp') || '',
          update: this.keyBiodataUpdates.includes('no_hp'),
        },
        {
          label: 'No Telepon (HP - WhatsApp)',
          value: this.$getDeepObj(this.biodataBaru, 'no_wa') || '',
          type: 'wa',
          update: this.keyBiodataUpdates.includes('no_wa'),
        },
        {
          label: 'No HP prabayar (aktif)',
          value: this.$getDeepObj(this.biodataBaru, 'no_hp_prabayar') || '',
          update: this.keyBiodataUpdates.includes('no_hp_prabayar'),
        },
        {
          label: 'Nama pemilik No HP Prabayar (aktif)',
          value: this.$getDeepObj(this.biodataBaru, 'nama_prabayar') || '',
          update: this.keyBiodataUpdates.includes('nama_prabayar'),
        },
        {
          label: 'Email (untuk kontak)',
          value: this.$getDeepObj(this.biodataBaru, 'email') || '',
          update: this.keyBiodataUpdates.includes('email'),
        },
        {
          label: 'Akun belajar.id yang diberikan oleh Direktorat sebagai FSP/PA',
          value: this.$getDeepObj(this.biodataBaru, 'akun_belajar_upt') || '-',
          update: this.keyBiodataUpdates.includes('akun_belajar_upt'),
        },
        {
          label: 'Akun belajar.id yang dimiliki / dari sekolah',
          value: this.$getDeepObj(this.biodataBaru, 'akun_belajar') || '-',
        },
      ];
    },

    pendidikan() {
      return [
        {
          label: 'Pendidikan Terakhir',
          value: this.$getDeepObj(this.biodataBaru, 'm_kualifikasi.keterangan') || '',
          update: this.keyBiodataUpdates.includes('k_kualifikasi'),
        },
        {
          label: 'Jurusan',
          value: this.$getDeepObj(this.biodataBaru, 'pendidikan_jurusan') || '',
          update: this.keyBiodataUpdates.includes('pendidikan_jurusan'),
        },
        {
          label: 'Bidang Pendidikan Terakhir',
          value: this.$getDeepObj(this.biodataBaru, 'm_profil_opsi_psp_pendidikan_bidang.keterangan') || '',
          update: this.keyBiodataUpdates.includes('k_pendidikan_bidang_psp'),
        },
        {
          label: 'Nama Instansi Pendidikan Terakhir',
          value: this.$getDeepObj(this.biodataBaru, 'pendidikan_instansi') || '',
          update: this.keyBiodataUpdates.includes('pendidikan_instansi'),
        },
      ];
    },

    penugasan() {
      return [
        {
          label: 'Pengalaman melakukan pendampingan peningkatan mutu pendidikan (pengalaman bersifat akumulasi)',
          value: this.$getDeepObj(this.biodataBaru, 'm_profil_opsi_psp_pendampingan.keterangan') || '',
          update: this.keyBiodataUpdates.includes('k_pendampingan_psp'),
        },
        {
          label: 'Unsur Fasilitator',
          value: this.$getDeepObj(this.biodataBaru, 'm_unsur_psp.keterangan') || '',
          update: this.keyBiodataUpdates.includes('k_unsur_psp'),
        },
        {
          label: 'Profesi/Pekerjaan saat ini',
          value: this.$getDeepObj(this.biodataBaru, 'profesi') || '',
          update: this.keyBiodataUpdates.includes('profesi'),
        },
      ];
    },

    instansiDaftar() {
      return [
        { label: 'Nama Instansi', value: this.$getDeepObj(this.pspProfil, 'instansi_nama') || '-' },
        { label: 'Alamat Instansi', value: this.$getDeepObj(this.pspProfil, 'instansi_alamat') || '-' },
        {
          label: 'Provinsi Instansi',
          value: this.$getDeepObj(this.pspProfil, 'm_propinsi_instansi.keterangan') || '-',
        },
        {
          label: 'Kabupaten/Kota Instansi',
          value: this.$getDeepObj(this.pspProfil, 'm_kota_instansi.keterangan') || '-',
        },
        { label: 'Website Instansi', value: this.$getDeepObj(this.pspProfil, 'instansi_situs') || '-' },
      ];
    },

    instansiSekarang() {
      return [
        {
          label: 'Apakah instansi Anda saat ini berubah dari yang ada di CV saat pendaftaran?',
          value: this.$getDeepObj(this.biodataBaru, 'k_beda_instansi_psp')
            ? this.mBedaInstansi[this.$getDeepObj(this.biodataBaru, 'k_beda_instansi_psp')] || ''
            : '',
          update: this.keyBiodataUpdates.includes('k_beda_instansi_psp'),
          size: 12,
        },
        {
          label: 'Nama Instansi',
          value: this.$getDeepObj(this.biodataBaru, 'instansi_nama') || '',
          update: this.keyBiodataUpdates.includes('instansi_nama'),
          hidden: this.$getDeepObj(this.biodataBaru, 'k_beda_instansi_psp') !== 51001,
        },
        {
          label: 'Alamat Instansi',
          value: this.$getDeepObj(this.biodataBaru, 'instansi_alamat') || '',
          update: this.keyBiodataUpdates.includes('instansi_alamat'),
          hidden: this.$getDeepObj(this.biodataBaru, 'k_beda_instansi_psp') !== 51001,
        },
        {
          label: 'Provinsi Instansi',
          value: this.$getDeepObj(this.biodataBaru, 'm_propinsi_instansi.keterangan') || '',
          update: this.keyBiodataUpdates.includes('instansi_k_propinsi'),
          hidden: this.$getDeepObj(this.biodataBaru, 'k_beda_instansi_psp') !== 51001,
        },
        {
          label: 'Kabupaten/Kota Instansi',
          value: this.$getDeepObj(this.biodataBaru, 'm_kota_instansi.keterangan') || '',
          update: this.keyBiodataUpdates.includes('instansi_k_kota'),
          hidden: this.$getDeepObj(this.biodataBaru, 'k_beda_instansi_psp') !== 51001,
        },
        {
          label: 'Website Instansi',
          value: this.$getDeepObj(this.biodataBaru, 'instansi_situs') || '',
          update: this.keyBiodataUpdates.includes('instansi_situs'),
          hidden: this.$getDeepObj(this.biodataBaru, 'k_beda_instansi_psp') !== 51001,
        },
      ];
    },

    instansiInduk() {
      return [
        {
          label: 'Apakah instansi Saat Ini sama dengan Instansi Induk Anda?',
          value: this.$getDeepObj(this.biodataBaru, 'k_beda_tugas_psp')
            ? this.mBedaTugas[this.$getDeepObj(this.biodataBaru, 'k_beda_tugas_psp')] || ''
            : '',
          update: this.keyBiodataUpdates.includes('k_beda_tugas_psp'),
          size: 12,
        },
        {
          label: 'Nama Instansi',
          value: this.$getDeepObj(this.biodataBaru, 'tugas_nama') || '',
          update: this.keyBiodataUpdates.includes('tugas_nama'),
          hidden: this.$getDeepObj(this.biodataBaru, 'k_beda_tugas_psp') !== 51001,
        },
        {
          label: 'Alamat Instansi',
          value: this.$getDeepObj(this.biodataBaru, 'tugas_alamat') || '',
          update: this.keyBiodataUpdates.includes('tugas_alamat'),
          hidden: this.$getDeepObj(this.biodataBaru, 'k_beda_tugas_psp') !== 51001,
        },
        {
          label: 'Provinsi Instansi',
          value: this.$getDeepObj(this.biodataBaru, 'm_propinsi_tugas.keterangan') || '',
          update: this.keyBiodataUpdates.includes('k_propinsi_tugas'),
          hidden: this.$getDeepObj(this.biodataBaru, 'k_beda_tugas_psp') !== 51001,
        },
        {
          label: 'Kabupaten/Kota Instansi',
          value: this.$getDeepObj(this.biodataBaru, 'm_kota_tugas.keterangan') || '',
          update: this.keyBiodataUpdates.includes('k_kota_tugas'),
          hidden: this.$getDeepObj(this.biodataBaru, 'k_beda_tugas_psp') !== 51001,
        },
        {
          label: 'Website Instansi',
          value: this.$getDeepObj(this.biodataBaru, 'tugas_situs') || '',
          update: this.keyBiodataUpdates.includes('tugas_situs'),
          hidden: this.$getDeepObj(this.biodataBaru, 'k_beda_tugas_psp') !== 51001,
        },
      ];
    },

    profil() {
      return {
        biodata: [
          { title: 'Data Diri', items: this.dasar },
          { title: 'Kontak', items: this.kontak },
          { title: 'Pendidikan terakhir', items: this.pendidikan },
          { title: 'Informasi Pendampingan', items: this.penugasan },
        ],
        instansi: [
          { title: 'Data Instansi (yang ada di CV saat pendaftaran)', items: this.instansiDaftar },
          { title: 'Data Instansi (saat ini)', items: this.instansiSekarang },
          { title: 'Data Instansi (induk)', items: this.instansiInduk },
        ],
        penugasan: [
          {
            items: [
              {
                label: 'Jenjang dan Jumlah Satuan Pendidikan Penugasan sebagai FSP Saat ini',
                value: this.$fkata(this.aktifs),
                update: this.tugasEdit['aktif'],
                size: 12,
              },
              {
                label: 'Jenjang satuan pendidikan yang pernah didampingi sebelumnya',
                value: this.$fkata(this.lamas),
                update: this.tugasEdit['selesai'],
                size: 12,
              },
              {
                label: 'Prioritas pendampingan jenjang satuan pendidikan jika terpilih sebagai fasilitator',
                value: this.rencanas.join('<br>'),
                update: this.tugasEdit['rencana'],
                size: 12,
              },
            ],
          },
        ],
        administrasi: [
          {
            items: [
              {
                label: 'Status Kepegawaian',
                value: this.$getDeepObj(this.biodataBaru, 'm_profil_opsi_psp_pegawai.keterangan') || '',
                update: this.keyBiodataUpdates.includes('k_pegawai_psp'),
              },
              {
                label: 'NIP',
                value: this.$getDeepObj(this.biodataBaru, 'nip') || '',
                update: this.keyBiodataUpdates.includes('nip'),
                hidden: !this.$getDeepObj(this.biodataBaru, 'nip'),
              },
              {
                label: 'Pangkat / Golongan',
                value: this.$getDeepObj(this.biodataBaru, 'm_golongan.keterangan') || '',
                update: this.keyBiodataUpdates.includes('k_golongan'),
                hidden: !this.$getDeepObj(this.biodataBaru, 'k_golongan'),
              },
              {
                label: 'NPWP',
                value: this.$getDeepObj(this.biodataBaru, 'npwp') || '',
                update: this.keyBiodataUpdates.includes('npwp'),
              },
              {
                label: 'Nama Bank dan Cabang Bank',
                value:
                  this.$getDeepObj(this.biodataBaru, 'rekening_bank') &&
                  this.$getDeepObj(this.biodataBaru, 'rekening_cabang')
                    ? `${this.$getDeepObj(this.biodataBaru, 'rekening_bank')} - ${this.$getDeepObj(
                        this.biodataBaru,
                        'rekening_cabang'
                      )}`
                    : '',
                update:
                  this.keyBiodataUpdates.includes('rekening_bank') || this.keyBiodataUpdates.includes('cabang_bank'),
              },
              {
                label: 'Nomor rekening',
                value: this.$getDeepObj(this.biodataBaru, 'rekening_nomor') || '',
                update: this.keyBiodataUpdates.includes('rekening_nomor'),
              },
              {
                label: 'Nama di Akun Bank',
                value: this.$getDeepObj(this.biodataBaru, 'rekening_nama') || '',
                update: this.keyBiodataUpdates.includes('rekening_nama'),
              },
            ],
          },
        ],
      };
    },

    dokumen() {
      let berkas = this.berkas.map((item) => {
        return {
          text: this.$getDeepObj(item, 'm_profil_berkas_psp.keterangan'),
          singkat: this.$getDeepObj(item, 'm_profil_berkas_psp.singkat'),
          value: item.psp_profil_berkas_id,
          url: item.url_berkas,
          update: this.keyBerkasUpdates.includes(item.psp_biodata_berkas_id),
        };
      });

      if (this.$getDeepObj(this.biodataBaru, 'meta.ajuan'))
        berkas.push({
          text: 'Pakta Integritas',
          singkat: 'pakta',
          value: this.$getDeepObj(this.biodataBaru, 'meta.ajuan.psp_peserta_ajuan_id'),
          url: this.$getDeepObj(this.biodataBaru, 'meta.ajuan.url_pakta'),
          update: this.keyBerkasUpdates.includes(this.$getDeepObj(this.biodataBaru, 'meta.ajuan.psp_peserta_ajuan_id')),
        });
      return berkas || [];
    },

    schema() {
      return {
        1: {
          label: 'Alasan ajuan ditolak',
          items: this.$mapForMaster(this.masters['alasan_verval'] && this.masters['alasan_verval']['tolak']),
        },
        2: {
          type: 'VTextarea',
          name: 'catatan',
          label: 'Catatan Setuju',
          labelColor: 'black',
          placeholder: 'Tuliskan alasan verval setuju',
          hint: '',
          grid: { cols: 12, md: 12 },
          required: false,
          outlined: true,
          singleLine: true,
        },
        3: {
          type: 'VTextarea',
          name: 'catatan',
          label: 'Catatan Perbaikan',
          labelColor: 'black',
          placeholder: 'Tuliskan alasan verval di tolak',
          hint: 'wajib diisi',
          grid: { cols: 12, md: 12 },
          required: true,
          outlined: true,
          singleLine: true,
        },
      };
    },

    mBtnPilihan() {
      const options = {
        setuju: {
          label: 'Setujui Ajuan',
          icon: 'mdi-check',
          color: 'success',
          value: 2,
        },
        revisi: {
          label: 'Tolak Perbaikan',
          icon: 'mdi-pencil',
          color: 'orange',
          value: 3,
        },
        tolak: {
          label: 'Ditolak',
          icon: 'mdi-close',
          color: 'red',
          value: 1,
        },
      };

      return [options.setuju, options.revisi];
    },

    isSasaranPop() {
      return this.$getDeepObj(this, 'detail.meta.is_sasaran_pop') || false;
    },
  },

  methods: {
    getValue() {
      return { pilihan: this.pilihan, id: this.id, catatan: (this.form && this.form.catatan) || '' };
    },

    reset() {
      this.pilihan = null;
      this.$set(this, 'form', {});
    },

    onDetail(item) {
      let info = [];

      // filter field yang membutuhkan nama
      if (
        ['ktp', 'ref_atasan', 'rekomendasi', 'ref_komunitas', 'ref_teman', 'dukungan', 'pernyataan'].indexOf(
          item.singkat
        ) > -1
      ) {
        info.push({
          label: 'Nama',
          value: this.$getDeepObj(this.biodataBaru, 'ptk.nama') || '',
        });
      }

      // filter field yang membutuhkan NIK
      if (['ktp'].indexOf(item.singkat) > -1) {
        info.push({
          label: 'NIK',
          value: this.$getDeepObj(this, 'detail.nik') || '',
        });
      }

      // filter field yang membutuhkan alamat
      if (['ktp'].indexOf(item.singkat) > -1) {
        info.push({
          label: 'Alamat',
          value: this.$getDeepObj(this, 'detail.alamat') || '',
        });
      }

      if (['pendukung'].indexOf(item.singkat) > -1) {
        info.push({
          label: 'Nama',
          value: this.$getDeepObj(this, 'detail.ptk.nama') || '-',
        });

        info.push({
          label: 'NIK',
          value: this.$getDeepObj(this, 'detail.nik') || '-',
        });
        info.push({
          label: 'Alamat',
          value: this.$getDeepObj(this, 'detail.ptk.alamat') || '-',
        });
        info.push({
          label: 'Tempat Tanggal Lahir',
          value: `${this.$getDeepObj(this, 'detail.ptk.tmp_lahir') || '-'} ${this.$localDate(
            this.$getDeepObj(this, 'detail.ptk.tgl_lahir'),
            true,
            false
          )}`,
        });
        info.push({
          label: 'Pendidikan',
          value: this.$getDeepObj(this, 'detail.m_kualifikasi.keterangan') || '-',
        });
        info.push({
          label: 'Jurusan',
          value: this.$getDeepObj(this, 'detail.jurusan') || '-',
        });

        info.push({
          label: 'Instansi',
          value: this.$getDeepObj(this, 'detail.instansi') || '-',
        });
      }

      if (['dukungan', 'rekomendasi', 'ref_komunitas'].indexOf(item.singkat) > -1) {
        info.push({
          label: 'NIP/NUPTK',
          value: this.$getDeepObj(this, 'detail.ptk.nip') || this.$getDeepObj(this, 'detail.ptk.nuptk') || '-',
        });
        info.push({
          label: 'Jabatan',
          value: this.$getDeepObj(this, 'detail.m_jabatan_gpm.keterangan') || '-',
        });
      }

      if (['ref_komunitas', 'rekomendasi', 'ref_atasan', 'ref_teman'].indexOf(item.singkat) > -1) {
        // info.push({
        //   label: 'Instansi',
        //   value: this.$getDeepObj(this, 'detail.sekolah.nama') || this.$getDeepObj(this, 'detail.ptk.instansi') || '-',
        // })
        info.push({
          label: 'Keterangan',
          value: `
            <ul>
                <li>Pastikan nama yang direkomendasikan adalah <b>${this.$getDeepObj(this, 'detail.ptk.nama')}</b></li>
                <li>Pastikan dokumen <b>ditandatangani</b> pemberi rekomendasi</li>
            </ul>`,
        });
      }

      if (['dukungan'].indexOf(item.singkat) > -1) {
        info.push({
          label: 'Keterangan',
          value: `
            <ul>
                <li>Pastikan surat dukungan di tujukan kepada  <b>${this.$getDeepObj(
                  this,
                  'detail.ptk.nama'
                )}</b> yang tertera pada dokumen</li>
                <li>Pastikan dokumen <b>ditandatangani</b> pemberi dukungan</li>
            </ul>`,
        });
      }

      this.$set(this.view, 'url', item.url);
      this.$set(this.view, 'title', item.text);
      this.$set(this.view, 'info', info);

      this.$nextTick(() => {
        this.$refs.view.open();
      });
    },

    onCall(value) {
      const url = `https://wa.me/62${value || Number(this.$getDeepObj(this.biodataBaru, 'no_wa'))}`;
      window.open(url, '_blank');
    },

    initForm(value) {
      this.$set(this, 'pilihan', (value && value.pilihan) || null);
    },

    onSelected(value) {
      // set
      this.$set(this, 'pilihan', value);
      this.$set(this.form, 'catatan', '');

      if (Number(value) === 2 || this.isDisable || !this.isEdit) return;

      // notifikasi untuk pilihan selain setuju
      const msg = {
        1: `<p class="subtitle-1 mb-0 black--text">Mohon Jelaskan secara spesifik dan rinci mengapa kandidat ditolak secara permanen</p>`,
        3: `<p class="subtitle-1 mb-0 black--text">Mohon Jelaskan perbaikan yang harus dilakukan secara spesifik dan rinci</p>`,
        4: `<p class="subtitle-1 mb-0 black--text">Mohon Jelaskan perbaikan yang harus dilakukan secara spesifik dan rinci</p>`,
      };
      this.$notifikasi(msg[this.pilihan], 'Informasi', {
        avatarColor: '#bbdefb',
        iconColor: 'info',
        btnColor: 'info',
      });
    },

    onPanduan() {
      const msg = this.jenis === 'instruktur' ? this.panduanPa : this.panduanKs;
      this.$notifikasi(msg, 'Informasi & Perbaikan Proses Verval', {
        withIcon: false,
        btnColor: 'info',
      });
    },

    onViewRekap() {
      this.$refs.rekap.open();
    },

    onConfirmSave() {
      this.$emit('confirm');
    },
  },
  watch: {
    initValue: 'initForm',
  },
};
</script>
<style scoped>
.bg-kiri {
  background: #bbdefb;
  height: 100%;
}
.custom-pnl >>> .v-expansion-panel-content__wrap {
  padding: 0;
}
</style>
